import Cookies from 'js-cookie';
import * as types from '../mutation-types';

// state
export const state = {
  themeColor: Cookies.get('themeColor'),
  loadingColor: Cookies.get('loadingColor'),
  backgroundLoadingColor: Cookies.get('backgroundLoadingColor'),
  sidebarColor: Cookies.get('sidebarColor'),
  navbartoggleColor: Cookies.get('navbartoggleColor'),
  toolbarColor: Cookies.get('toolbarColor'),
  navbarColor: Cookies.get('navbarColor'),
  profileColor: Cookies.get('profileColor'),
  graphicColor: Cookies.get('graphicColor'),
  navlinkColor: Cookies.get('navlinkColor'),
};

// getters
export const getters = {
  themeColor: (state) => state.themeColor,
  loadingColor: (state) => state.loadingColor,
  backgroundLoadingColor: (state) => state.backgroundLoadingColor,
  sidebarColor: (state) => state.sidebarColor,
  navbartoggleColor: (state) => state.navbartoggleColor,
  toolbarColor: (state) => state.toolbarColor,
  navbarColor: (state) => state.navbarColor,
  profileColor: (state) => state.profileColor,
  graphicColor: (state) => state.graphicColor,
  navlinkColor: (state) => state.navlinkColor,
};

// mutations
export const mutations = {
  [types.SET_THEME_COLOR](state, { value }) {
    switch (value) {
      case 'blue':
        state.themeColor = 'blue darken-1';
        state.loadingColor = 'indigo lighten-1';
        state.backgroundLoadingColor = 'deep-purple lighten-5';
        state.sidebarColor = 'sidebarmenu-tblue';
        state.navbartoggleColor = 'navbartoggle-tblue';
        state.toolbarColor = 'toolbar-tblue';
        state.navbarColor = 'navbar-tblue';
        state.profileColor = 'profile-tblue';
        state.graphicColor = '#1E88E5';
        state.navlinkColor = 'navlink-tblue';

        Cookies.set('themeColor', 'blue darken-1');
        Cookies.set('loadingColor', 'indigo lighten-1');
        Cookies.set('backgroundLoadingColor', 'deep-purple lighten-5');
        Cookies.set('sidebarColor', 'sidebarmenu-tblue');
        Cookies.set('navbartoggleColor', 'navbartoggle-tblue');
        Cookies.set('toolbarColor', 'toolbar-tblue');
        Cookies.set('navbarColor', 'navbar-tblue');
        Cookies.set('profileColor', 'profile-tblue');
        Cookies.set('graphicColor', '#1E88E5');
        Cookies.set('navlinkColor', 'navlink-tblue');
        break;
      case 'red':
        state.themeColor = 'red darken-1';
        state.loadingColor = 'red accent-3';
        state.backgroundLoadingColor = 'red lighten-4';
        state.sidebarColor = 'sidebarmenu-tred';
        state.navbartoggleColor = 'navbartoggle-tred';
        state.toolbarColor = 'toolbar-tred';
        state.navbarColor = 'navbar-tred';
        state.profileColor = 'profile-tred';
        state.graphicColor = '#E53935';
        state.navlinkColor = 'navlink-tred';

        Cookies.set('themeColor', 'red darken-1');
        Cookies.set('loadingColor', 'red accent-3');
        Cookies.set('backgroundLoadingColor', 'red lighten-4');
        Cookies.set('sidebarColor', 'sidebarmenu-tred');
        Cookies.set('navbartoggleColor', 'navbartoggle-tred');
        Cookies.set('toolbarColor', 'toolbar-tred');
        Cookies.set('navbarColor', 'navbar-tred');
        Cookies.set('profileColor', 'profile-tred');
        Cookies.set('graphicColor', '#E53935');
        Cookies.set('navlinkColor', 'navlink-tred');
        break;
      case 'purple':
        state.themeColor = 'purple darken-1';
        state.loadingColor = 'purple accent-4';
        state.backgroundLoadingColor = 'purple lighten-4';
        state.sidebarColor = 'sidebarmenu-tpurple';
        state.navbartoggleColor = 'navbartoggle-tpurple';
        state.toolbarColor = 'toolbar-tpurple';
        state.navbarColor = 'navbar-tpurple';
        state.profileColor = 'profile-tpurple';
        state.graphicColor = '#AB47BC';
        state.navlinkColor = 'navlink-tpurple';

        Cookies.set('themeColor', 'purple darken-1');
        Cookies.set('loadingColor', 'purple accent-4');
        Cookies.set('backgroundLoadingColor', 'purple lighten-4');
        Cookies.set('sidebarColor', 'sidebarmenu-tpurple');
        Cookies.set('navbartoggleColor', 'navbartoggle-tpurple');
        Cookies.set('toolbarColor', 'toolbar-tpurple');
        Cookies.set('navbarColor', 'navbar-tpurple');
        Cookies.set('profileColor', 'profile-tpurple');
        Cookies.set('graphicColor', '#AB47BC');
        Cookies.set('navlinkColor', 'navlink-tpurple');
        break;
      case 'green':
        state.themeColor = 'green darken-1';
        state.loadingColor = 'light-green accent-4';
        state.backgroundLoadingColor = 'green accent-1';
        state.sidebarColor = 'sidebarmenu-tgreen';
        state.navbartoggleColor = 'navbartoggle-tgreen';
        state.toolbarColor = 'toolbar-tgreen';
        state.navbarColor = 'navbar-tgreen';
        state.profileColor = 'profile-tgreen';
        state.graphicColor = '#66BB6A';
        state.navlinkColor = 'navlink-tgreen';

        Cookies.set('themeColor', 'green darken-1');
        Cookies.set('loadingColor', 'light-green accent-4');
        Cookies.set('backgroundLoadingColor', 'green lightent-4');
        Cookies.set('sidebarColor', 'sidebarmenu-tgreen');
        Cookies.set('navbartoggleColor', 'navbartoggle-tgreen');
        Cookies.set('toolbarColor', 'toolbar-tgreen');
        Cookies.set('navbarColor', 'navbar-tgreen');
        Cookies.set('profileColor', 'profile-tgreen');
        Cookies.set('graphicColor', '#66BB6A');
        Cookies.set('navlinkColor', 'navlink-tgreen');
        break;
      case 'orange':
        state.themeColor = 'orange darken-1';
        state.loadingColor = 'amber darken-3';
        state.backgroundLoadingColor = 'amber lightent-3';
        state.sidebarColor = 'sidebarmenu-torange';
        state.navbartoggleColor = 'navbartoggle-torange';
        state.toolbarColor = 'toolbar-torange';
        state.navbarColor = 'navbar-torange';
        state.profileColor = 'profile-torange';
        state.graphicColor = '#FFA726';
        state.navlinkColor = 'navlink-torange';

        Cookies.set('themeColor', 'orange darken-1');
        Cookies.set('loadingColor', 'amber darken-3');
        Cookies.set('backgroundLoadingColor', 'amber lightent-3');
        Cookies.set('sidebarColor', 'sidebarmenu-torange');
        Cookies.set('navbartoggleColor', 'navbartoggle-torange');
        Cookies.set('toolbarColor', 'toolbar-torange');
        Cookies.set('navbarColor', 'navbar-torange');
        Cookies.set('profileColor', 'profile-torange');
        Cookies.set('graphicColor', '#FFA726');
        Cookies.set('navlinkColor', 'navlink-torange');
        break;
      case 'fucsia':
        state.themeColor = 'pink lighten-1';
        state.loadingColor = 'pink accent-2';
        state.backgroundLoadingColor = 'pink lightent-5';
        state.sidebarColor = 'sidebarmenu-tfucsia';
        state.navbartoggleColor = 'navbartoggle-tfucsia';
        state.toolbarColor = 'toolbar-tfucsia';
        state.navbarColor = 'navbar-tfucsia';
        state.profileColor = 'profile-tfucsia';
        state.graphicColor = '#FF4081';
        state.navlinkColor = 'navlink-tfucsia';

        Cookies.set('themeColor', 'pink lighten-1');
        Cookies.set('loadingColor', 'pink accent-2');
        Cookies.set('backgroundLoadingColor', 'pink lightent-5');
        Cookies.set('sidebarColor', 'sidebarmenu-tfucsia');
        Cookies.set('navbartoggleColor', 'navbartoggle-tfucsia');
        Cookies.set('toolbarColor', 'toolbar-tfucsia');
        Cookies.set('navbarColor', 'navbar-tfucsia');
        Cookies.set('profileColor', 'profile-tfucsia');
        Cookies.set('graphicColor', '#FF4081');
        Cookies.set('navlinkColor', 'navlink-tfucsia');
        break;
      case 'teal':
        state.themeColor = 'teal lighten-1';
        state.loadingColor = 'cyan darken-1';
        state.backgroundLoadingColor = 'cyan lighten-4';
        state.sidebarColor = 'sidebarmenu-tteal';
        state.navbartoggleColor = 'navbartoggle-tteal';
        state.toolbarColor = 'toolbar-tteal';
        state.navbarColor = 'navbar-tteal';
        state.profileColor = 'profile-tteal';
        state.graphicColor = '#4DB6AC';
        state.navlinkColor = 'navlink-tteal';

        Cookies.set('themeColor', 'teal lighten-1');
        Cookies.set('loadingColor', 'cyan darken-1');
        Cookies.set('backgroundLoadingColor', 'cyan lighten-4');
        Cookies.set('sidebarColor', 'sidebarmenu-tteal');
        Cookies.set('navbartoggleColor', 'navbartoggle-tteal');
        Cookies.set('toolbarColor', 'toolbar-tteal');
        Cookies.set('navbarColor', 'navbar-tteal');
        Cookies.set('profileColor', 'profile-tteal');
        Cookies.set('graphicColor', '#4DB6AC');
        Cookies.set('navlinkColor', 'navlink-tteal');
        break;
      case 'lightblue':
        state.themeColor = 'light-blue accent-2';
        state.loadingColor = 'cyan lighten-2';
        state.backgroundLoadingColor = 'teal lighten-5';
        state.sidebarColor = 'sidebarmenu-tlightblue';
        state.navbartoggleColor = 'navbartoggle-tlightblue';
        state.toolbarColor = 'toolbar-tlightblue';
        state.navbarColor = 'navbar-tlightblue';
        state.profileColor = 'profile-tlightblue';
        state.graphicColor = '#81D4FA';
        state.navlinkColor = 'navlink-tlightblue';

        Cookies.set('themeColor', 'light-blue accent-2');
        Cookies.set('loadingColor', 'cyan lighten-2');
        Cookies.set('backgroundLoadingColor', 'teal lighten-5');
        Cookies.set('sidebarColor', 'sidebarmenu-tlightblue');
        Cookies.set('navbartoggleColor', 'navbartoggle-tlightblue');
        Cookies.set('toolbarColor', 'toolbar-tlightblue');
        Cookies.set('navbarColor', 'navbar-tlightblue');
        Cookies.set('profileColor', 'profile-tlightblue');
        Cookies.set('graphicColor', '#81D4FA');
        Cookies.set('navlinkColor', 'navlink-tlightblue');
        break;
      default:
        state.themeColor = 'blue darken-1';
        state.loadingColor = 'indigo lighten-1';
        state.backgroundLoadingColor = 'deep-purple lighten-5';
        state.sidebarColor = 'sidebarmenu-tblue';
        state.navbartoggleColor = 'navbartoggle-tblue';
        state.toolbarColor = 'toolbar-tblue';
        state.navbarColor = 'navbar-tblue';
        state.profileColor = 'profile-tblue';
        state.graphicColor = '#1E88E5';
        state.navlinkColor = 'navlink-tblue';

        Cookies.set('themeColor', 'blue darken-1');
        Cookies.set('loadingColor', 'indigo lighten-1');
        Cookies.set('backgroundLoadingColor', 'deep-purple lighten-5');
        Cookies.set('sidebarColor', 'sidebarmenu-tblue');
        Cookies.set('navbartoggleColor', 'navbartoggle-tblue');
        Cookies.set('toolbarColor', 'toolbar-tblue');
        Cookies.set('navbarColor', 'navbar-tblue');
        Cookies.set('profileColor', 'profile-tblue');
        Cookies.set('graphicColor', '#1E88E5');
        Cookies.set('navlinkColor', 'navlink-tblue');
        break;
    }
  },
};

// actions
export const actions = {
  setThemeColor({ commit }, { value }) {
    commit(types.SET_THEME_COLOR, { value });
  },
};
